import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledShareDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(504)}, 86vw);
  }
  
  .DialogContent {
    padding: ${props => props.theme.spacing(3)};
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledShareDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledShareDialog;
